module.exports = __webpack_public_path__ + "img/mianshiyaoqing.6b474b22.png";